var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-container custom-font"},[(_vm.isReady)?_c('router-view'):_c('span',[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }